/**
 * Stable `data-tour` id for a portal sidebar link, derived from its url so the
 * sidebars and the tour catalogue agree without hard-coded indexes:
 *   "/portal/owner/properties" → "nav-owner-properties"
 *   "/portal/tenant"           → "nav-tenant"
 */
export function navTourId(url: string): string {
  const slug = url
    .replace(/^\/portal\//, "")
    .replace(/^\/+|\/+$/g, "")
    .replace(/\//g, "-");
  return `nav-${slug}`;
}
